import type { RecipeV2Doc, RecipeV2Summary } from '@ctcells/api'
import { intlLocale, t } from '@ctcells/i18n'

import { AddModal } from '../../atoms/AddModal.tsx'
import { EmptyState } from '../../atoms/EmptyState.tsx'
import { FormHint, FormSection } from '../formSections.tsx'
import { RecipeDocBody } from '../templates/RecipeDocBody.tsx'

/** 상세 팝업이 읽는 한 레시피의 문서 · 서버 요약(`POST /recipes/summary` — 그 레시피 id 로 묻는다) */
export interface RecipeDetailDoc {
  recipeId: string
  loading: boolean
  doc?: RecipeV2Doc | undefined
  summary?: RecipeV2Summary | undefined
  /** 못 물은 까닭(권한 · 통신) — 팝업 본문 자리에만 */
  notice?: string | undefined
}

/**
 * 레시피 상세 팝업 — 레시피 표 줄 끝 [상세](eric 2026-10-21 「상세 버튼을 클릭하면.. 팝업 창이 뜨면서. 해당 레시피의 내용을 보이게 해줘.
 * 지금은.. 아래에.. 길게 넣잖아.. 팝업창을 띄워줘」). 고르지 않은 레시피도 연다.
 *
 * - 창은 «추가 창» 원자(`AddModal`) 그대로 — 시료 팝업 둘과 같은 꼴. Esc 는 이 팝업만 닫는다(`Modal` 열린 창 줄)
 * - 본문은 템플릿 상세와 같은 부품(`RecipeDocBody`) · 읽기 전용. 🔸 트레이(시료 자리 그림 + 자리 목록)를 **켠다** — 이 팝업은 레시피 한 벌을
 *   통째로 보는 자리라 시료 자리도 그 레시피의 내용이다. 바깥 창 시료 구역 그림과는 다른 창이라 한 화면에 겹치지 않는다
 * - 🔴 **바닥 줄이 없다** — 상세만 보인다(eric 2026-10-22 「이미 고른 레시피입니다. 취소 이 레시피 선택 버튼을 없애줘 상세만 보여주면 돼」).
 *   닫기는 오른쪽 위 × · Esc · 바깥 누름, 레시피 고르기는 바깥 표의 라디오가 한다
 * 🔴 받는 중 · 못 받음은 팝업 안에만 — 바깥 창을 막지 않는다
 */
export function RecipeDetailPopup({
  title,
  detail,
  onClose,
}: {
  /** 「이름 · v1」 */
  title: string
  detail: RecipeDetailDoc | undefined
  onClose: () => void
}) {
  const body =
    detail?.notice !== undefined ? (
      <p className="deny" role="alert">
        {detail.notice}
      </p>
    ) : detail?.doc !== undefined && detail.summary !== undefined ? (
      <RecipeDocBody
        doc={detail.doc}
        headRows={[
          {
            key: 'commands',
            label: t('recipeTemplate.commands'),
            value: detail.summary.commands.total.toLocaleString(intlLocale()),
          },
        ]}
        summary={detail.summary}
      />
    ) : detail?.loading === true ? (
      <FormHint role="status">{t('state.loading')}</FormHint>
    ) : (
      <EmptyState />
    )

  return (
    <AddModal size="md" onClose={onClose} title={title}>
      <FormSection wide>
        <div className="nbrecipe">{body}</div>
      </FormSection>
    </AddModal>
  )
}
